// URL canonicalization is separate from immutable page/stock identity.
export function landingCanonicalPath(fullPath, markets) {
  const path = `/${String(fullPath || "").replace(/^\/+|\/+$/g, "")}`;
  const parts = path.split("/");
  const market = markets[parts[1]];
  const language = parts[2]?.toLowerCase();
  const defaultLanguage = market?.defaultLanguage?.toLowerCase();
  const isDefault = language === defaultLanguage ||
    (["br", "in"].includes(parts[1]) && language === defaultLanguage?.split("-")[0]);
  return market && parts.length > 3 && isDefault
    ? `/${parts[1]}/${parts.slice(3).join("/")}` : path;
}